// test2305
(2305 && 0);
